/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationScopeCategory } from './EvaluationScopeCategory';
import {
    EvaluationScopeCategoryFromJSON,
    EvaluationScopeCategoryFromJSONTyped,
    EvaluationScopeCategoryToJSON,
} from './EvaluationScopeCategory';
import type { CreateEvaluationParameterDto } from './CreateEvaluationParameterDto';
import {
    CreateEvaluationParameterDtoFromJSON,
    CreateEvaluationParameterDtoFromJSONTyped,
    CreateEvaluationParameterDtoToJSON,
} from './CreateEvaluationParameterDto';

/**
 * 
 * @export
 * @interface CreateEvaluationParameterScopeDto
 */
export interface CreateEvaluationParameterScopeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEvaluationParameterScopeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEvaluationParameterScopeDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEvaluationParameterScopeDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {EvaluationScopeCategory}
     * @memberof CreateEvaluationParameterScopeDto
     */
    evaluationScopeCategory?: EvaluationScopeCategory;
    /**
     * 
     * @type {string}
     * @memberof CreateEvaluationParameterScopeDto
     */
    condition?: string | null;
    /**
     * 
     * @type {Array<CreateEvaluationParameterDto>}
     * @memberof CreateEvaluationParameterScopeDto
     */
    evaluationParameters?: Array<CreateEvaluationParameterDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEvaluationParameterScopeDto
     */
    $type?: CreateEvaluationParameterScopeDtoTypeEnum;
}


/**
 * @export
 */
export const CreateEvaluationParameterScopeDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateEvaluationParameterScopeDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateEvaluationParameterScopeDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateEvaluationParameterScopeDtoTypeEnum = typeof CreateEvaluationParameterScopeDtoTypeEnum[keyof typeof CreateEvaluationParameterScopeDtoTypeEnum];



/**
 * Check if a given object implements the CreateEvaluationParameterScopeDto interface.
 */
export function instanceOfCreateEvaluationParameterScopeDto(value?: unknown): value is CreateEvaluationParameterScopeDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateEvaluationParameterScopeDtoTypeEnum)[0];
}

export function CreateEvaluationParameterScopeDtoFromJSON(json: any): CreateEvaluationParameterScopeDto {
    return CreateEvaluationParameterScopeDtoFromJSONTyped(json, false);
}

export function CreateEvaluationParameterScopeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEvaluationParameterScopeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'evaluationScopeCategory': json['evaluationScopeCategory'] == null ? undefined : EvaluationScopeCategoryFromJSON(json['evaluationScopeCategory']),
        'condition': json['condition'] == null ? undefined : json['condition'],
        'evaluationParameters': json['evaluationParameters'] == null ? undefined : ((json['evaluationParameters'] as Array<any>).map(CreateEvaluationParameterDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateEvaluationParameterScopeDtoToJSON(value?: CreateEvaluationParameterScopeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'isEnabled': value['isEnabled'],
        'evaluationScopeCategory': EvaluationScopeCategoryToJSON(value['evaluationScopeCategory']),
        'condition': value['condition'],
        'evaluationParameters': value['evaluationParameters'] == null ? undefined : ((value['evaluationParameters'] as Array<any>).map(CreateEvaluationParameterDtoToJSON)),
        '$type': value['$type'],
    });
}

